import { useIntl } from 'react-intl'
import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { logError } from '../../toaster'
import {
  applicationSecuritySummaryFacetsRequest,
  ApplicationSecuritySummaryFacetsRequestParams
} from './requests/application-security-summary-facets-request'

export const useApplicationSecuritySummaryFacets = (
  params: ApplicationSecuritySummaryFacetsRequestParams
) => {
  const { data, ...rest } = useContrastQuery(
    [Query.VR_AGGREGATIONS, params],
    applicationSecuritySummaryFacetsRequest,
    params,
    {
      keepPreviousData: true
    }
  )

  const intl = useIntl()

  if (rest.isError) {
    console.error(rest.error.message)
    logError(
      intl.formatMessage({
        id: 'title_valueReporting_unableToApplyFilters'
      })
    )
  }

  return {
    ...rest,
    data: {
      aggregations: data?.aggregations || {},
      applicationSecuritySummaryFacetsRequest:
        data?.applicationMetadataConfigurations || {},
      totalCount: data?.totalCount || 0
    }
  }
}
